import React from 'react';
import {connect} from 'react-redux';

import {t, dt} from 'l10n';
import AutoSuggest from 'components/autosuggest/AutoSuggest';
import AutoSuggestDataProvider from 'containers/member/AutosuggestDataProvider';

import {followProfile} from 'reducers/member';
//import ModalBecomeXXL from 'components/modals/ModalBecomeXXL';

class FollowForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: null,
            error: null,
            pending: false,
//            showModal: false
        };

        this.onFollowButtonClick = this.onFollowButtonClick.bind(this);
    }

    onFollowButtonClick(e) {
        e.preventDefault();

        const {currentUser, dispatch} = this.props;

        //if (!currentUser.isXXL()) {
        //    this.setState({showModal: true});
        //    return;
        //}

        const {user} = this.state;

        this.setState({
            pending: true,
            error: null
        });

        let action = followProfile(user.id, user);

        dispatch(action);

        action.promise
            .then(() => this.setState({user: null, pending: false}))
            .catch((e) => this.setState({error: e.message, pending: false}))
    }

    render() {
        const {user, error, pending /*, showModal*/} = this.state;

        const dataProvider = new AutoSuggestDataProvider();

        return (
            <div className="search-follow">

                <form>
                    <div>
                        {error && <p className="error">{error}</p>}
                        <AutoSuggest
                            placeholder={t('Search by name')}
                            dataProvider={dataProvider}
                            onSelect={(item) => this.setState({user: item})}
                            value={user ? user.nick : ''}
                        />
                    </div>
                    <div className="button-block">
                        <div>
                            <button
                                type="submit"
                                className={'ui-button primary btn-submit ' + (pending ? 'loading' : '')}
                                disabled={user && !pending ? null : 'disabled'}
                                onClick={this.onFollowButtonClick}
                            >
                                {pending ? t('Please wait...') : t('Follow')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        currentUser: state.currentUser
    }),
    null
)(FollowForm);


// WEBPACK FOOTER //
// ./src/containers/member/follow/FollowForm.js